(function() {
    angular
        .module('emarket.main.post')
        .controller('ShareSheetController', ['$window', '$mdBottomSheet', 'Socialshare', 'ImageTransformer', 'post', function($window,
            $mdBottomSheet,
            Socialshare,
            ImageTransformer,
            post) {
            var vm = this;
            vm.post = post;
            vm.socialShareUrl = $window.location.href;
            var sharePost = function(provider, attrs) {
                attrs = attrs = {};
                attrs.socialshareDisplay = 'iframe';
                attrs.socialshareTitle = vm.post.title;
                attrs.socialshareUrl = $window.location.href;
                if (vm.post.images.length > 0) {
                    var image = ImageTransformer.get(vm.post.images[0].path, ImageTransformer.LARGE);
                    attrs.socialshareMedia = image;

                    attrs.socialshareDescription = vm.post.title + ' ' + vm.post.prices.list;

                    attrs.socialshareBody =
            'Hola, te comparto este producto que vi en eMarket ' + vm.post.title;
                }
                // attrs.socialshareMedia = window.location.href;
                // attrs.socialshareMedia = Utils.getUrl() + '/' + vm.post.images.paths;
                //TODO get the media and the url
                attrs.socialshareText = vm.post.title;
                attrs.socialshareSubject = vm.post.title;
                Socialshare.share({
                    provider: provider,
                    attrs: attrs
                });
            };
            vm.shareFacebook = function() {
                $mdBottomSheet.hide();
                sharePost('facebook', {
                    socialshareType: 'share',
                    socialshareVia: '392697910777737'
                });
            };
            vm.shareTwitter = function() {
                $mdBottomSheet.hide();
                sharePost('twitter');
            };

            vm.shareWhatsapp = function() {};
        }]);
}());
